import apiSlice from "state/api/apiSlice";

export const accountApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateAccount: builder.mutation({
      query: (user) => ({
        url: "/auth/",
        method: "PUT",
        body: {
          ...user,
        },
      }),
    }),
  }),
});

export const { useUpdateAccountMutation } = accountApiSlice;
